@if (data.contents && data.contents.length) {
  <p #p [attr.data-testid]="'text-content-paragraph'">
    @for (content of $any(data.contents); track content) {
      <flex-span
        [data]="content"
        [bubble]="bubble"
        [flex]="flex"
        [level]="level + 1"
        [class.active]="content.isSelect"
        (click)="
          $event.stopPropagation(); flexEditorService.selected$.next(content)
        "
      >
      </flex-span>
    }
  </p>
} @else {
  <p #p [innerHTML]="dataText" [attr.data-testid]="'text-content'"></p>
}

@if (hasShareAction(data)) {
  <ms-share-preview
    [messageId]="data.action['messageId']"
    [shareCurrentMessage]="data.action['shareCurrentMessage']"
    [package]="flexEditorService.package"
    class="absolute right-0 top-1/2 -translate-y-1/2"
  ></ms-share-preview>
}
